import React, { useCallback, useState } from 'react';
import { ScrollView, View, Switch } from 'react-native';
import { useMutation } from '@apollo/client';
import DataTable from '@preflighttech/preflight-tables';

import { ButtonGroup } from 'app/src/elements/buttons';
import minimalTable from 'app/src/elements/minimalTable';
import * as colors from 'app/src/styles/colors';

import { Button } from './elements';
import { CREATE_BID_GROUP, UPDATE_BID_GROUP } from './queries';

const BidGroup = ({ selectedSaleAsset, saleAssets, setShowModal }) => {
  const id = selectedSaleAsset.pendingBidGroupId;

  const [selectedIds, setSelectedIds] = useState(
    id ?
    saleAssets.filter(saleAsset => id === saleAsset.pendingBidGroupId).
      map(saleAsset => saleAsset.id) :
    [selectedSaleAsset.id]
  );

  const [createBidGroup] = useMutation(CREATE_BID_GROUP, {
    onCompleted: () => setShowModal(false)
  });

  const [updateBidGroup] = useMutation(UPDATE_BID_GROUP, {
    onCompleted: () => setShowModal(false)
  });

  const saveBidGroup = () => {
    if (id) {
      updateBidGroup({ variables: { id, saleAssetIds: selectedIds } });
    } else {
      createBidGroup({ variables: { saleAssetIds: selectedIds } });
    }
  };

  const clearBidGroup = () => {
    updateBidGroup({ variables: { id, saleAssetIds: [] } });
  };

  const activeRef = useCallback(element => {
    if (element) {
      element.scrollIntoView();
    }
  }, []);

  const toggleSelectedId = id => {
    if (selectedIds.includes(id)) {
      setSelectedIds(selectedIds.filter(selectedId => selectedId !== id));
    } else {
      setSelectedIds([...selectedIds, id]);
    }
  };

  const columns = [
    {
      key: 'id',
      label: 'Include?',
      sort: 'prevent',
      width: 100,
      content: ({ entry }) => {
        if (
          selectedIds.includes(entry.id) ||
          'Pending' === entry.biddingStatus
        ) {
          if (entry.pendingBidGroupId && entry.pendingBidGroupId !== id) {
            return 'Choice';
          } else {
            return (
              <Switch
                value={selectedIds.includes(entry.id)}
                onValueChange={() => toggleSelectedId(entry.id)}
              />
            );
          }
        } else {
          return entry.biddingStatus;
        }
      }
    },
    {
      key: 'lotNumber',
      label: 'Lot #',
      sort: 'prevent',
      width: 100,
    },
    {
      key: 'asset',
      label: 'Asset',
      sort: 'prevent',
      value: ({ value }) => value.name,
      content: ({ entry, value }) => (
        <span ref={selectedIds[0] === entry.id ? activeRef : null}>
          {value}
        </span>
      )
    },
  ];

  return (
    <>
      <ScrollView style={{height: 300}}>
        <DataTable.Simple
          data={saleAssets}
          columns={columns}
          component={minimalTable}
          pageLength="All"
          htmlTable
        />
      </ScrollView>

      <ButtonGroup>
        <Button
          title="Save"
          onPress={saveBidGroup}
          disabled={selectedIds.length < 2}
        />
        {id && (
          <Button
            title="Clear Group"
            onPress={clearBidGroup}
            color={colors.elRed}
          />
         )}
      </ButtonGroup>
    </>
  );
};

export default BidGroup;
